webpackJsonp([19],{

/***/ 1541:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BackupManagement_vue__ = __webpack_require__(1917);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13f6a7f8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BackupManagement_vue__ = __webpack_require__(2385);
function injectStyle (ssrContext) {
  __webpack_require__(2383)
}
var normalizeComponent = __webpack_require__(951)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-13f6a7f8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BackupManagement_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13f6a7f8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BackupManagement_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1544:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Button_vue__ = __webpack_require__(1546);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64c87b52_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Button_vue__ = __webpack_require__(1555);
function injectStyle (ssrContext) {
  __webpack_require__(1553)
}
var normalizeComponent = __webpack_require__(951)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-64c87b52"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Button_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64c87b52_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Button_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1545:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Otwarte modale w kolejności otwierania. Esc zamyka tylko ostatni, żeby przy
// zagnieżdżonych modalach (np. wykres otwierany z modala szczegółów alarmów)
// nie zamykały się wszystkie naraz.
var openModals = [];

// Esc w otwartej liście vue-select / vue-multiselect zamyka samą listę; przy
// otwartym kalendarzu vue2-datepicker też nie ruszamy modala, żeby jednym
// klawiszem nie stracić wypełnionego formularza.
var OPEN_DROPDOWN = '.vs--open, .multiselect--active';
var OPEN_DATEPICKER = '.mx-datepicker-popup';

// Faza capture: sprawdzamy listy, zanim ich własna obsługa Esc je zamknie.
function onDocumentKeydown(event) {
    if (event.key !== 'Escape' && event.key !== 'Esc') return;

    var topModal = openModals[openModals.length - 1];
    if (topModal == null) return;

    var target = event.target;
    if (target instanceof Element && target.closest(OPEN_DROPDOWN) != null) return;
    if (document.querySelector(OPEN_DATEPICKER) != null) return;

    topModal.$emit('close');
}

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'Modal',
    props: {
        showDialog: {
            type: Boolean,
            required: false,
            default: false
        },
        maxWidth: {
            type: String,
            required: false,
            default: ''
        },
        title: {
            type: String,
            required: false,
            default: ''
        }
    },
    watch: {
        showDialog: {
            immediate: true,
            handler: function handler(isOpen) {
                isOpen ? this.registerOpen() : this.unregisterOpen();
            }
        }
    },
    beforeDestroy: function beforeDestroy() {
        this.unregisterOpen();
    },

    computed: {
        style: function style() {
            return 'max-width: ' + this.maxWidth;
        }
    },
    methods: {
        registerOpen: function registerOpen() {
            if (openModals.includes(this)) return;
            openModals.push(this);
            if (openModals.length === 1) {
                document.addEventListener('keydown', onDocumentKeydown, true);
            }
        },
        unregisterOpen: function unregisterOpen() {
            var index = openModals.indexOf(this);
            if (index === -1) return;
            openModals.splice(index, 1);
            if (openModals.length === 0) {
                document.removeEventListener('keydown', onDocumentKeydown, true);
            }
        }
    }
});

/***/ }),

/***/ 1546:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  emits: ['onClick'],
  props: {
    title: {
      type: String,
      default: '',
      required: false
    },
    buttonClass: {
      type: String,
      default: '',
      required: false
    }
  },
  data: function data() {
    return {};
  },

  methods: {
    onClick: function onClick() {
      this.$emit('onClick');
    }
  },
  computed: {
    buttonDef: function buttonDef() {
      return this.buttonClass === '' ? 'my-button' : '' + this.buttonClass;
    }
  }
});

/***/ }),

/***/ 1547:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Modal_vue__ = __webpack_require__(1545);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_330662f6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Modal_vue__ = __webpack_require__(1551);
function injectStyle (ssrContext) {
  __webpack_require__(1549)
}
var normalizeComponent = __webpack_require__(951)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-330662f6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Modal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_330662f6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Modal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1548:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _from = __webpack_require__(1558);

var _from2 = _interopRequireDefault(_from);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return (0, _from2.default)(arr);
  }
};

/***/ }),

/***/ 1549:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1550);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1502)("6de141c4", content, true, {});

/***/ }),

/***/ 1550:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1501)(true);
// imports


// module
exports.push([module.i, ".modal[data-v-330662f6]{position:fixed;z-index:110;left:0;top:0;width:100%;height:100%;overflow:auto;display:block;background-color:rgba(0,0,0,.4)}.flex-container[data-v-330662f6]{height:100%;padding:0;margin:0;display:-webkit-box;display:-ms-flexbox;display:flex}.modal-content[data-v-330662f6]{margin:auto;background-color:#fefefe;border:unset;width:auto;z-index:1000;border-radius:5px;-webkit-box-shadow:0 4px 10px rgba(0,0,0,.2);box-shadow:0 4px 10px rgba(0,0,0,.2)}.modal-header[data-v-330662f6]{background-color:#34758e;width:100%;font-family:SourceSansProBold,sans-serif;font-size:16px;font-style:normal;font-weight:600;color:#fff}.close[data-v-330662f6]{color:#fff;float:right;font-size:28px;font-weight:700}.close[data-v-330662f6]:focus,.close[data-v-330662f6]:hover{color:#000;text-decoration:none;cursor:pointer}.widthClass[data-v-330662f6]{max-width:30%}#mdiv[data-v-330662f6]{width:25px;height:25px;cursor:pointer}.mdiv[data-v-330662f6]{height:25px;width:2px;margin-left:12px;background-color:#fff;-webkit-transform:rotate(45deg);transform:rotate(45deg);Z-index:1}.md[data-v-330662f6]{height:25px;width:2px;background-color:#fff;-webkit-transform:rotate(90deg);transform:rotate(90deg);Z-index:2}", "", {"version":3,"sources":["/Users/sleepingwarrior/BioControl/crfi-monitoring/UI/crfi_monitoring/src/components/Modal.vue"],"names":[],"mappings":"AACA,wBACI,eAAgB,AAGhB,YAAa,AACb,OAAQ,AACR,MAAO,AACP,WAAY,AACZ,YAAa,AACb,cAAe,AACf,cAAe,AACf,+BAAkC,CACrC,AACD,iCACI,YAAa,AACb,UAAW,AACX,SAAU,AACV,oBAAqB,AACrB,oBAAqB,AACrB,YAAc,CACjB,AAKD,gCACI,YAAa,AACb,yBAA0B,AAC1B,aAAc,AACd,WAAY,AACZ,aAAc,AACd,kBAAmB,AACnB,6CAAiD,AACzC,oCAAyC,CACpD,AACD,+BACI,yBAA2B,AAC3B,WAAY,AACZ,yCAA6C,AAC7C,eAAgB,AAChB,kBAAmB,AACnB,gBAAiB,AACjB,UAAa,CAChB,AACD,wBACI,WAAa,AACb,YAAa,AACb,eAAgB,AAChB,eAAkB,CACrB,AACD,4DAEI,WAAa,AACb,qBAAsB,AACtB,cAAgB,CACnB,AACD,6BACI,aAAe,CAClB,AAKD,uBACE,WAAY,AACZ,YAAa,AACb,cAAgB,CACjB,AACD,uBACE,YAAa,AACb,UAAW,AACX,iBAAkB,AAClB,sBAAwB,AACxB,gCAAiC,AACzB,wBAAyB,AACjC,SAAW,CACZ,AACD,qBACE,YAAa,AACb,UAAW,AACX,sBAAwB,AACxB,gCAAiC,AACzB,wBAAyB,AACjC,SAAW,CACZ","file":"Modal.vue","sourcesContent":["\n.modal[data-v-330662f6] {\n    position: fixed;\n    /* Nad paskiem górnym (.app-header, z-index 20) i mobilnym menu (99/100),\n       ale pod popupami doklejanymi do body (Syncfusion 1000, datepicker 2001). */\n    z-index: 110;\n    left: 0;\n    top: 0;\n    width: 100%;\n    height: 100%;\n    overflow: auto;\n    display: block;\n    background-color: rgba(0,0,0,0.4);\n}\n.flex-container[data-v-330662f6] {\n    height: 100%;\n    padding: 0;\n    margin: 0;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n}\n\n/* margin: auto zamiast align-items/justify-content: center — modal wyższy od\n   ekranu zaczyna się od góry i da się go przewinąć do nagłówka z krzyżykiem\n   (przy centrowaniu flexem jego górna część wystawała poza ekran). */\n.modal-content[data-v-330662f6] {\n    margin: auto;\n    background-color: #fefefe;\n    border: unset;\n    width: auto;\n    z-index: 1000;\n    border-radius: 5px;\n    -webkit-box-shadow: 0px 4px 10px rgba(0,0,0,0.2);\n            box-shadow: 0px 4px 10px rgba(0,0,0,0.2);\n}\n.modal-header[data-v-330662f6] {\n    background-color:  #34758E;\n    width: 100%;\n    font-family: \"SourceSansProBold\", sans-serif;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 600;\n    color: white;\n}\n.close[data-v-330662f6] {\n    color: white;\n    float: right;\n    font-size: 28px;\n    font-weight: bold;\n}\n.close[data-v-330662f6]:hover,\n.close[data-v-330662f6]:focus {\n    color: black;\n    text-decoration: none;\n    cursor: pointer;\n}\n.widthClass[data-v-330662f6] {\n    max-width: 30%;\n}\n.modal-slot[data-v-330662f6] {\n    /* margin-right: 10px;\n    margin-left: 10px; */\n}\n#mdiv[data-v-330662f6] {\n  width: 25px;\n  height: 25px;\n  cursor: pointer;\n}\n.mdiv[data-v-330662f6] {\n  height: 25px;\n  width: 2px;\n  margin-left: 12px;\n  background-color: white;\n  -webkit-transform: rotate(45deg);\n          transform: rotate(45deg);\n  Z-index: 1;\n}\n.md[data-v-330662f6] {\n  height: 25px;\n  width: 2px;\n  background-color: white;\n  -webkit-transform: rotate(90deg);\n          transform: rotate(90deg);\n  Z-index: 2;\n}\n\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1551:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showDialog)?_c('div',{staticClass:"modal flex-container"},[_c('div',{staticClass:"modal-content vertical",style:(_vm.style)},[_c('div',{staticClass:"modal-header"},[(_vm.title != undefined)?_c('p',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.title != null ? _vm.title : '')+" ")]):_vm._e(),_vm._v(" "),_c('div',{attrs:{"id":"mdiv"},on:{"click":function($event){return _vm.$emit('close')}}},[_vm._m(0)])]),_vm._v(" "),_c('div',{staticClass:"modal-slot"},[_vm._t("default")],2)])]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mdiv"},[_c('div',{staticClass:"md"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1553:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1554);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1502)("9f84328e", content, true, {});

/***/ }),

/***/ 1554:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1501)(true);
// imports


// module
exports.push([module.i, ".my-button[data-v-64c87b52]{background:transparent;outline:none;border:none}", "", {"version":3,"sources":["/Users/sleepingwarrior/BioControl/crfi-monitoring/UI/crfi_monitoring/src/components/Button.vue"],"names":[],"mappings":"AACA,4BACI,uBAAwB,AACxB,aAAc,AACd,WAAa,CAChB","file":"Button.vue","sourcesContent":["\n.my-button[data-v-64c87b52] {\n    background: transparent;\n    outline: none;\n    border: none;\n}\n.my-button[data-v-64c87b52]:hover {\n}\n\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1555:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:_vm.buttonDef,attrs:{"type":"button"},on:{"click":_vm.onClick}},[_vm._v(_vm._s(_vm.$t(_vm.title))+"\n  "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1558:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1559), __esModule: true };

/***/ }),

/***/ 1559:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(960);
__webpack_require__(1560);
module.exports = __webpack_require__(105).Array.from;


/***/ }),

/***/ 1560:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(222);
var $export = __webpack_require__(183);
var toObject = __webpack_require__(954);
var call = __webpack_require__(966);
var isArrayIter = __webpack_require__(967);
var toLength = __webpack_require__(446);
var createProperty = __webpack_require__(1561);
var getIterFn = __webpack_require__(962);

$export($export.S + $export.F * !__webpack_require__(968)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),

/***/ 1561:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(184);
var createDesc = __webpack_require__(447);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),

/***/ 1563:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Button__ = __webpack_require__(1544);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        title: {
            type: String,
            required: false
        },
        text: {
            type: String,
            required: false,
            default: ''
        },
        alternativeDeleteText: {
            type: String,
            required: false,
            default: 'AreYouSureDelete'
        }
    },
    watch: {},
    methods: {
        confirm: function confirm() {
            this.$emit('confirm');
        },
        cancel: function cancel() {
            this.$emit('cancel');
        }
    },
    computed: {},
    components: {
        Button: __WEBPACK_IMPORTED_MODULE_0__components_Button__["a" /* default */]
    },
    mounted: function mounted() {},
    data: function data() {
        return {};
    }
});

/***/ }),

/***/ 1576:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_uuid__ = __webpack_require__(1585);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_uuid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_uuid__);


//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
	name: "ProbablyOverflowingTextCell.vue",
	data: function data() {
		return {
			data: {},
			uuid: "0",
			init: false,
			interval: null
		};
	},

	computed: {
		text: function text() {
			return this.data[this.data.column.field];
		}
	},
	methods: {
		setVisible: function setVisible() {
			if (this.init) {
				try {
					var e = document.getElementById(this.uuid);
					var res = e.offsetWidth < e.scrollWidth;
					if (res) {
						e._tippy.enable();
					} else {
						e._tippy.disable();
					}
					clearInterval(this.interval);
				} catch (ignored) {}
			}
		}
	},
	mounted: function () {
		var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
			var _this = this;

			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
				while (1) {
					switch (_context.prev = _context.next) {
						case 0:
							this.uuid = Object(__WEBPACK_IMPORTED_MODULE_2_uuid__["v4"])();
							this.init = true;
							this.interval = setInterval(function () {
								return _this.setVisible();
							}, 50);

						case 3:
						case "end":
							return _context.stop();
					}
				}
			}, _callee, this);
		}));

		function mounted() {
			return _ref.apply(this, arguments);
		}

		return mounted;
	}()
});

/***/ }),

/***/ 1577:
/***/ (function(module, exports) {

// Unique ID creation requires a high quality random # generator.  In the
// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection

// getRandomValues needs to be invoked in a context where "this" is a Crypto
// implementation. Also, find the complete implementation of crypto on IE11.
var getRandomValues = (typeof(crypto) != 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto)) ||
                      (typeof(msCrypto) != 'undefined' && typeof window.msCrypto.getRandomValues == 'function' && msCrypto.getRandomValues.bind(msCrypto));

if (getRandomValues) {
  // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
  var rnds8 = new Uint8Array(16); // eslint-disable-line no-undef

  module.exports = function whatwgRNG() {
    getRandomValues(rnds8);
    return rnds8;
  };
} else {
  // Math.random()-based (RNG)
  //
  // If all else fails, use Math.random().  It's fast, but is of unspecified
  // quality.
  var rnds = new Array(16);

  module.exports = function mathRNG() {
    for (var i = 0, r; i < 16; i++) {
      if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
      rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
    }

    return rnds;
  };
}


/***/ }),

/***/ 1578:
/***/ (function(module, exports) {

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */
var byteToHex = [];
for (var i = 0; i < 256; ++i) {
  byteToHex[i] = (i + 0x100).toString(16).substr(1);
}

function bytesToUuid(buf, offset) {
  var i = offset || 0;
  var bth = byteToHex;
  // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
  return ([
    bth[buf[i++]], bth[buf[i++]],
    bth[buf[i++]], bth[buf[i++]], '-',
    bth[buf[i++]], bth[buf[i++]], '-',
    bth[buf[i++]], bth[buf[i++]], '-',
    bth[buf[i++]], bth[buf[i++]], '-',
    bth[buf[i++]], bth[buf[i++]],
    bth[buf[i++]], bth[buf[i++]],
    bth[buf[i++]], bth[buf[i++]]
  ]).join('');
}

module.exports = bytesToUuid;


/***/ }),

/***/ 1579:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DeleteConfirm_vue__ = __webpack_require__(1563);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_905c32ac_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DeleteConfirm_vue__ = __webpack_require__(1582);
function injectStyle (ssrContext) {
  __webpack_require__(1580)
}
var normalizeComponent = __webpack_require__(951)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-905c32ac"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DeleteConfirm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_905c32ac_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DeleteConfirm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1580:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1581);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1502)("727af110", content, true, {});

/***/ }),

/***/ 1581:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1501)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"DeleteConfirm.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 1582:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pl-5 pr-5"},[_c('p',{staticClass:"mb-0 pt-4",staticStyle:{"text-align":"center","font-weight":"600","font-size":"18px"}},[_vm._v(_vm._s(_vm.text))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t(_vm.alternativeDeleteText)))]),_vm._v(" "),_c('div',{staticClass:"row d-flex justify-content-between pb-4 mt-4 ml-4 mr-4"},[_c('div',{staticClass:"col flex-grow pr-2"},[_c('Button',{attrs:{"title":_vm.$t('Cancel'),"buttonClass":"cancel-button semi-bold w-100"},on:{"onClick":_vm.cancel}})],1),_vm._v(" "),_c('div',{staticClass:"col flex-grow pl-2"},[_c('Button',{attrs:{"title":_vm.$t('Delete'),"buttonClass":"delete-button semi-bold w-100"},on:{"onClick":_vm.confirm}})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1585:
/***/ (function(module, exports, __webpack_require__) {

var v1 = __webpack_require__(1591);
var v4 = __webpack_require__(1592);

var uuid = v4;
uuid.v1 = v1;
uuid.v4 = v4;

module.exports = uuid;


/***/ }),

/***/ 1586:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProbablyOverflowingTextCell_vue__ = __webpack_require__(1576);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e2e6411_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProbablyOverflowingTextCell_vue__ = __webpack_require__(1593);
function injectStyle (ssrContext) {
  __webpack_require__(1587)
  __webpack_require__(1589)
}
var normalizeComponent = __webpack_require__(951)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6e2e6411"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProbablyOverflowingTextCell_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e2e6411_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProbablyOverflowingTextCell_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1587:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1588);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1502)("28d11c4b", content, true, {});

/***/ }),

/***/ 1588:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1501)(true);
// imports


// module
exports.push([module.i, ".tippy-popper[x-placement^=bottom] .tippy-tooltip.customTheme-theme .tippy-arrow{border-bottom:8px solid #346f8b}", "", {"version":3,"sources":["/Users/sleepingwarrior/BioControl/crfi-monitoring/UI/crfi_monitoring/src/components/Systems/ProbablyOverflowingTextCell.vue"],"names":[],"mappings":"AACA,iFACC,+BAAiC,CACjC","file":"ProbablyOverflowingTextCell.vue","sourcesContent":["\n.tippy-popper[x-placement^=bottom] .tippy-tooltip.customTheme-theme .tippy-arrow {\n\tborder-bottom: 8px solid #346F8B;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1589:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1590);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1502)("42116436", content, true, {});

/***/ }),

/***/ 1590:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1501)(true);
// imports


// module
exports.push([module.i, ".tippy-tooltip.customTheme-theme[data-v-6e2e6411]{background-color:#346f8b}", "", {"version":3,"sources":["/Users/sleepingwarrior/BioControl/crfi-monitoring/UI/crfi_monitoring/src/components/Systems/ProbablyOverflowingTextCell.vue"],"names":[],"mappings":"AACA,kDACC,wBAA0B,CAC1B","file":"ProbablyOverflowingTextCell.vue","sourcesContent":["\n.tippy-tooltip.customTheme-theme[data-v-6e2e6411] {\n\tbackground-color: #346F8B;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1591:
/***/ (function(module, exports, __webpack_require__) {

var rng = __webpack_require__(1577);
var bytesToUuid = __webpack_require__(1578);

// **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html

var _nodeId;
var _clockseq;

// Previous uuid creation time
var _lastMSecs = 0;
var _lastNSecs = 0;

// See https://github.com/uuidjs/uuid for API details
function v1(options, buf, offset) {
  var i = buf && offset || 0;
  var b = buf || [];

  options = options || {};
  var node = options.node || _nodeId;
  var clockseq = options.clockseq !== undefined ? options.clockseq : _clockseq;

  // node and clockseq need to be initialized to random values if they're not
  // specified.  We do this lazily to minimize issues related to insufficient
  // system entropy.  See #189
  if (node == null || clockseq == null) {
    var seedBytes = rng();
    if (node == null) {
      // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
      node = _nodeId = [
        seedBytes[0] | 0x01,
        seedBytes[1], seedBytes[2], seedBytes[3], seedBytes[4], seedBytes[5]
      ];
    }
    if (clockseq == null) {
      // Per 4.2.2, randomize (14 bit) clockseq
      clockseq = _clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
    }
  }

  // UUID timestamps are 100 nano-second units since the Gregorian epoch,
  // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
  // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
  // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
  var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();

  // Per 4.2.1.2, use count of uuid's generated during the current clock
  // cycle to simulate higher resolution clock
  var nsecs = options.nsecs !== undefined ? options.nsecs : _lastNSecs + 1;

  // Time since last uuid creation (in msecs)
  var dt = (msecs - _lastMSecs) + (nsecs - _lastNSecs)/10000;

  // Per 4.2.1.2, Bump clockseq on clock regression
  if (dt < 0 && options.clockseq === undefined) {
    clockseq = clockseq + 1 & 0x3fff;
  }

  // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
  // time interval
  if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === undefined) {
    nsecs = 0;
  }

  // Per 4.2.1.2 Throw error if too many uuids are requested
  if (nsecs >= 10000) {
    throw new Error('uuid.v1(): Can\'t create more than 10M uuids/sec');
  }

  _lastMSecs = msecs;
  _lastNSecs = nsecs;
  _clockseq = clockseq;

  // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
  msecs += 12219292800000;

  // `time_low`
  var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
  b[i++] = tl >>> 24 & 0xff;
  b[i++] = tl >>> 16 & 0xff;
  b[i++] = tl >>> 8 & 0xff;
  b[i++] = tl & 0xff;

  // `time_mid`
  var tmh = (msecs / 0x100000000 * 10000) & 0xfffffff;
  b[i++] = tmh >>> 8 & 0xff;
  b[i++] = tmh & 0xff;

  // `time_high_and_version`
  b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
  b[i++] = tmh >>> 16 & 0xff;

  // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
  b[i++] = clockseq >>> 8 | 0x80;

  // `clock_seq_low`
  b[i++] = clockseq & 0xff;

  // `node`
  for (var n = 0; n < 6; ++n) {
    b[i + n] = node[n];
  }

  return buf ? buf : bytesToUuid(b);
}

module.exports = v1;


/***/ }),

/***/ 1592:
/***/ (function(module, exports, __webpack_require__) {

var rng = __webpack_require__(1577);
var bytesToUuid = __webpack_require__(1578);

function v4(options, buf, offset) {
  var i = buf && offset || 0;

  if (typeof(options) == 'string') {
    buf = options === 'binary' ? new Array(16) : null;
    options = null;
  }
  options = options || {};

  var rnds = options.random || (options.rng || rng)();

  // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
  rnds[6] = (rnds[6] & 0x0f) | 0x40;
  rnds[8] = (rnds[8] & 0x3f) | 0x80;

  // Copy bytes to buffer, if provided
  if (buf) {
    for (var ii = 0; ii < 16; ++ii) {
      buf[i + ii] = rnds[ii];
    }
  }

  return buf || bytesToUuid(rnds);
}

module.exports = v4;


/***/ }),

/***/ 1593:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{directives:[{name:"tippy",rawName:"v-tippy",value:({ theme : 'customTheme', placement : 'bottom-start', arrow : true }),expression:"{ theme : 'customTheme', placement : 'bottom-start', arrow : true }"}],staticStyle:{"text-overflow":"ellipsis","width":"100%","overflow":"hidden"},attrs:{"id":_vm.uuid,"content":_vm.text}},[_vm._v("\n\t\t"+_vm._s(_vm.text)+"\n\t")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1603:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var BYTES_PER_MB = 1048576;

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'ProgressBar',
    props: {
        loaded: {
            type: Number,
            default: 0
        },
        total: {
            type: Number,
            default: 0
        }
    },
    computed: {
        indeterminate: function indeterminate() {
            return !(this.total > 0);
        },
        percent: function percent() {
            if (this.indeterminate) return 0;
            return Math.min(100, this.loaded / this.total * 100);
        },
        label: function label() {
            if (this.indeterminate) {
                // Size unknown: show what we have, or "Preparing" before any bytes.
                return this.loaded > 0 ? this.toMB(this.loaded) + ' MB' : this.$t('Preparing');
            }
            return this.toMB(this.loaded) + ' MB / ' + this.toMB(this.total) + ' MB';
        }
    },
    methods: {
        toMB: function toMB(bytes) {
            return (bytes / BYTES_PER_MB).toFixed(2);
        }
    }
});

/***/ }),

/***/ 1607:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProgressBar_vue__ = __webpack_require__(1603);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d4018aa0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProgressBar_vue__ = __webpack_require__(1667);
function injectStyle (ssrContext) {
  __webpack_require__(1665)
}
var normalizeComponent = __webpack_require__(951)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d4018aa0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProgressBar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d4018aa0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProgressBar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1608:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = parseProgress;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_finite__ = __webpack_require__(1668);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_finite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_finite__);

// Cross-browser parsing of axios up/download progress events.
//
// axios 1.x sets `progressEvent.total` to `undefined` whenever the transfer is
// not length-computable. For downloads this happens routinely when the response
// is gzip/br compressed, chunked or streamed – and whether it happens depends on
// the server<->browser content negotiation, which is why the old code worked in
// some browsers/setups but not others.
//
// To behave identically everywhere we recover the total from, in order:
//   1. progressEvent.total          (reliable, only set when length-computable)
//   2. a caller-supplied known size (e.g. the file's real byte size)
//   3. the Content-Length response header read straight off the XHR
// and, when none is available, we report `indeterminate` so the UI can render an
// animated "in progress" bar instead of a stuck/NaN one.

function parseProgress(progressEvent) {
    var fallbackTotal = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

    var loaded = toPositive(progressEvent && progressEvent.loaded) || 0;

    var total = toPositive(progressEvent && progressEvent.total);

    if (!total) {
        total = toPositive(fallbackTotal);
    }

    if (!total) {
        total = toPositive(contentLength(progressEvent));
    }

    // A total smaller than the bytes already transferred means the header
    // describes the compressed payload while `loaded` counts decompressed
    // bytes – the percentage would be meaningless, so treat it as unknown.
    if (total && loaded > total) {
        total = 0;
    }

    return {
        loaded: loaded,
        total: total,
        indeterminate: !total
    };
}

function contentLength(progressEvent) {
    var xhr = progressEvent && progressEvent.event && progressEvent.event.target;
    if (xhr && typeof xhr.getResponseHeader === 'function') {
        return Number(xhr.getResponseHeader('Content-Length'));
    }
    return 0;
}

function toPositive(value) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_finite___default()(value) && value > 0 ? value : 0;
}

/***/ }),

/***/ 1665:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1666);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1502)("74e4044a", content, true, {});

/***/ }),

/***/ 1666:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1501)(true);
// imports


// module
exports.push([module.i, ".progress-container[data-v-d4018aa0]{margin:10px 20px}.progress-head[data-v-d4018aa0]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:baseline;-ms-flex-align:baseline;align-items:baseline;margin-bottom:6px;font-size:14px;color:#414f51}.progress-percent[data-v-d4018aa0]{font-weight:600;color:#356c88}.crfi-progress[data-v-d4018aa0]{position:relative;width:100%;height:12px;border-radius:6px;background-color:#e3ebee;-webkit-box-shadow:inset 0 1px 2px rgba(0,0,0,.1);box-shadow:inset 0 1px 2px rgba(0,0,0,.1);overflow:hidden}.crfi-progress-bar[data-v-d4018aa0]{height:100%;border-radius:6px;background-color:#356c88;-webkit-transition:width .2s linear;transition:width .2s linear}.crfi-progress-bar.indeterminate[data-v-d4018aa0]{position:absolute;left:0;top:0;width:40%;-webkit-animation:crfi-progress-indeterminate-data-v-d4018aa0 1.4s ease-in-out infinite;animation:crfi-progress-indeterminate-data-v-d4018aa0 1.4s ease-in-out infinite}@-webkit-keyframes crfi-progress-indeterminate-data-v-d4018aa0{0%{-webkit-transform:translateX(-100%);transform:translateX(-100%)}to{-webkit-transform:translateX(250%);transform:translateX(250%)}}@keyframes crfi-progress-indeterminate-data-v-d4018aa0{0%{-webkit-transform:translateX(-100%);transform:translateX(-100%)}to{-webkit-transform:translateX(250%);transform:translateX(250%)}}", "", {"version":3,"sources":["/Users/sleepingwarrior/BioControl/crfi-monitoring/UI/crfi_monitoring/src/components/ProgressBar.vue"],"names":[],"mappings":"AACA,qCACI,gBAAkB,CACrB,AACD,gCACI,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,8BAA+B,AACvC,2BAA4B,AACxB,wBAAyB,AACrB,qBAAsB,AAC9B,kBAAmB,AACnB,eAAgB,AAChB,aAAe,CAClB,AACD,mCACI,gBAAiB,AACjB,aAAe,CAClB,AACD,gCACI,kBAAmB,AACnB,WAAY,AACZ,YAAa,AACb,kBAAmB,AACnB,yBAA0B,AAC1B,kDAAuD,AAC/C,0CAA+C,AACvD,eAAiB,CACpB,AACD,oCACI,YAAa,AACb,kBAAmB,AACnB,yBAA0B,AAC1B,oCAAsC,AACtC,2BAA8B,CACjC,AACD,kDACI,kBAAmB,AACnB,OAAQ,AACR,MAAO,AACP,UAAW,AACX,wFAAyF,AACjF,+EAAiF,CAC5F,AACD,+DACA,GAAO,oCAAqC,AAAC,2BAA6B,CACzE,AACD,GAAK,mCAAoC,AAAC,0BAA4B,CACrE,CACA,AACD,uDACA,GAAO,oCAAqC,AAAC,2BAA6B,CACzE,AACD,GAAK,mCAAoC,AAAC,0BAA4B,CACrE,CACA","file":"ProgressBar.vue","sourcesContent":["\n.progress-container[data-v-d4018aa0] {\n    margin: 10px 20px;\n}\n.progress-head[data-v-d4018aa0] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: justify;\n        -ms-flex-pack: justify;\n            justify-content: space-between;\n    -webkit-box-align: baseline;\n        -ms-flex-align: baseline;\n            align-items: baseline;\n    margin-bottom: 6px;\n    font-size: 14px;\n    color: #414F51;\n}\n.progress-percent[data-v-d4018aa0] {\n    font-weight: 600;\n    color: #356C88;\n}\n.crfi-progress[data-v-d4018aa0] {\n    position: relative;\n    width: 100%;\n    height: 12px;\n    border-radius: 6px;\n    background-color: #e3ebee;\n    -webkit-box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.1);\n            box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.1);\n    overflow: hidden;\n}\n.crfi-progress-bar[data-v-d4018aa0] {\n    height: 100%;\n    border-radius: 6px;\n    background-color: #356C88;\n    -webkit-transition: width 0.2s linear;\n    transition: width 0.2s linear;\n}\n.crfi-progress-bar.indeterminate[data-v-d4018aa0] {\n    position: absolute;\n    left: 0;\n    top: 0;\n    width: 40%;\n    -webkit-animation: crfi-progress-indeterminate-data-v-d4018aa0 1.4s ease-in-out infinite;\n            animation: crfi-progress-indeterminate-data-v-d4018aa0 1.4s ease-in-out infinite;\n}\n@-webkit-keyframes crfi-progress-indeterminate-data-v-d4018aa0 {\nfrom { -webkit-transform: translateX(-100%); transform: translateX(-100%);\n}\nto { -webkit-transform: translateX(250%); transform: translateX(250%);\n}\n}\n@keyframes crfi-progress-indeterminate-data-v-d4018aa0 {\nfrom { -webkit-transform: translateX(-100%); transform: translateX(-100%);\n}\nto { -webkit-transform: translateX(250%); transform: translateX(250%);\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1667:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progress-container vertical"},[_c('div',{staticClass:"progress-head"},[_c('span',{staticClass:"progress-label"},[_vm._v(_vm._s(_vm.label))]),_vm._v(" "),(!_vm.indeterminate)?_c('span',{staticClass:"progress-percent"},[_vm._v(_vm._s(_vm.percent.toFixed(0))+"%")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"crfi-progress",attrs:{"role":"progressbar","aria-valuemin":"0","aria-valuemax":_vm.indeterminate ? null : _vm.total,"aria-valuenow":_vm.indeterminate ? null : _vm.loaded}},[(_vm.indeterminate)?_c('div',{staticClass:"crfi-progress-bar indeterminate"}):_c('div',{staticClass:"crfi-progress-bar",style:({ width: _vm.percent + '%' })})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1668:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1669), __esModule: true };

/***/ }),

/***/ 1669:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1670);
module.exports = __webpack_require__(105).Number.isFinite;


/***/ }),

/***/ 1670:
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.2 Number.isFinite(number)
var $export = __webpack_require__(183);
var _isFinite = __webpack_require__(80).isFinite;

$export($export.S, 'Number', {
  isFinite: function isFinite(it) {
    return typeof it == 'number' && _isFinite(it);
  }
});


/***/ }),

/***/ 1917:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(1548);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(952);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__syncfusion_ej2_vue_grids__ = __webpack_require__(953);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Systems_ProbablyOverflowingTextCell_vue__ = __webpack_require__(1586);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Modal_vue__ = __webpack_require__(1547);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_DeleteConfirm_vue__ = __webpack_require__(1579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_ProgressBar_vue__ = __webpack_require__(1607);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util_progress__ = __webpack_require__(1608);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//














var context = null;

/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        ProbablyOverflowingTextCell: __WEBPACK_IMPORTED_MODULE_6__components_Systems_ProbablyOverflowingTextCell_vue__["a" /* default */],
        Modal: __WEBPACK_IMPORTED_MODULE_7__components_Modal_vue__["a" /* default */],
        DeleteConfirm: __WEBPACK_IMPORTED_MODULE_9__components_DeleteConfirm_vue__["a" /* default */],
        ProgressBar: __WEBPACK_IMPORTED_MODULE_10__components_ProgressBar_vue__["a" /* default */]
    },
    provide: {
        grid: [__WEBPACK_IMPORTED_MODULE_5__syncfusion_ej2_vue_grids__["l" /* Sort */], __WEBPACK_IMPORTED_MODULE_5__syncfusion_ej2_vue_grids__["i" /* Page */], __WEBPACK_IMPORTED_MODULE_5__syncfusion_ej2_vue_grids__["g" /* Filter */], __WEBPACK_IMPORTED_MODULE_5__syncfusion_ej2_vue_grids__["m" /* Toolbar */], __WEBPACK_IMPORTED_MODULE_5__syncfusion_ej2_vue_grids__["k" /* Search */], __WEBPACK_IMPORTED_MODULE_5__syncfusion_ej2_vue_grids__["b" /* CommandColumn */], __WEBPACK_IMPORTED_MODULE_5__syncfusion_ej2_vue_grids__["j" /* PdfExport */], __WEBPACK_IMPORTED_MODULE_5__syncfusion_ej2_vue_grids__["f" /* ExcelExport */]]
    },
    data: function data() {
        return {
            versions: [],
            // VIEW MANAGEMENT
            activeModal: null,
            activeData: null,
            selectedBackupId: null,
            actionText: null,
            // PROGRESS
            bytesReceived: 0,
            bytesToReceive: 0,
            downloadController: null,
            // GRID
            dateTimeFormatOptions: { format: 'yyyy-MM-dd HH:mm:ss', type: 'dateTime' },
            pageSettings: { pageSize: 100, pageSizes: [10, 25, 50, 100] },
            toolbar: ['Search'],
            wrapSettings: { wrapMode: 'Header' },
            selectionOptions: { type: 'Multiple' },
            filterOptions: {
                type: 'Menu'
            },
            filterCheckBox: {
                type: 'CheckBox'
            },
            customAttributes: { class: 'customcss' },
            backups: [],
            optionsTemplate: function optionsTemplate() {
                return {
                    template: __WEBPACK_IMPORTED_MODULE_8_vue__["default"].component('optionsTemplate', {
                        template: '\n                            <div class="horizontal grow">\n                                <div style="cursor: pointer; margin: 5px" v-on:click="onClick(\'Download\')" :content="$t(\'Download\')" v-tippy="{ theme : \'customTheme\', placement : \'left\', arrow : true }">\n                                   <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 21H18M12 3V17M12 17L17 12M12 17L7 12" stroke="#346F8B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>\n                                </div>\n                                <div style="cursor: pointer; margin: 5px" v-on:click="onClick(\'DELETE\')" content="' + context.$t('Delete') + '" v-tippy="{ theme : \'customTheme\', placement : \'left\', arrow : true }">\n                                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.5 1.4C3.5 0.626801 4.1268 0 4.9 0H9.1C9.8732 0 10.5 0.626801 10.5 1.4V2.8H11.8928C11.8971 2.79996 11.9014 2.79996 11.9058 2.8H13.3C13.6866 2.8 14 3.1134 14 3.5C14 3.8866 13.6866 4.2 13.3 4.2H12.5518L11.9447 12.6997C11.8923 13.4324 11.2827 14 10.5482 14H3.45178C2.71729 14 2.10767 13.4324 2.05534 12.6997L1.44822 4.2H0.7C0.313401 4.2 0 3.8866 0 3.5C0 3.1134 0.313401 2.8 0.7 2.8H2.09422C2.09856 2.79996 2.1029 2.79996 2.10722 2.8H3.5V1.4ZM4.9 2.8H9.1V1.4H4.9V2.8ZM2.85178 4.2L3.45178 12.6H10.5482L11.1482 4.2H2.85178ZM5.6 5.6C5.9866 5.6 6.3 5.9134 6.3 6.3V10.5C6.3 10.8866 5.9866 11.2 5.6 11.2C5.2134 11.2 4.9 10.8866 4.9 10.5V6.3C4.9 5.9134 5.2134 5.6 5.6 5.6ZM8.4 5.6C8.7866 5.6 9.1 5.9134 9.1 6.3V10.5C9.1 10.8866 8.7866 11.2 8.4 11.2C8.0134 11.2 7.7 10.8866 7.7 10.5V6.3C7.7 5.9134 8.0134 5.6 8.4 5.6Z" fill="#346F8B"/></svg>\n                                </div>\n                            </div>\n                        ',
                        data: function data() {
                            return {
                                data: {}
                            };
                        },
                        methods: {
                            onClick: function onClick(mode) {
                                switch (mode) {
                                    case 'Download':
                                        context.downloadBackup(this.data.id, this.data.fileName, this.data.fileSize);
                                        break;
                                    case 'DELETE':
                                        context.deleteVersion(this.data);
                                        break;
                                }
                            }
                        }
                    })
                };
            },
            TextTemplate: function TextTemplate() {
                return {
                    template: {
                        extends: __WEBPACK_IMPORTED_MODULE_6__components_Systems_ProbablyOverflowingTextCell_vue__["a" /* default */]
                    }
                };
            }
        };
    },

    methods: {
        getData: function getData() {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                var backupsList;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return Object(__WEBPACK_IMPORTED_MODULE_3__api__["_16" /* getBackupsOverview */])();

                            case 2:
                                backupsList = _context.sent;


                                backupsList.forEach(function (element) {
                                    element.sizeText = element.fileSize.formatBytes(2);
                                });

                                _this.backups = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(backupsList));

                            case 5:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        dataBound: function dataBound() {
            this.$refs.grid.autoFitColumns();
        },
        openModal: function openModal(data, modal) {
            this.activeModal = modal;
            this.activeData = data;
        },
        closeModal: function closeModal(isGetData) {
            var _this2 = this;

            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                if (!isGetData) {
                                    _context2.next = 3;
                                    break;
                                }

                                _context2.next = 3;
                                return _this2.getData();

                            case 3:

                                _this2.actionText = null;
                                _this2.selectedBackupId = null;

                                _this2.openModal(null, null);

                            case 6:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this2);
            }))();
        },
        deleteVersion: function deleteVersion(backup) {
            var _this3 = this;

            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _this3.actionText = 'Delete backup: ' + backup.systemName + ' | ' + backup.createDate;
                                _this3.activeModal = 'DELETE';
                                _this3.selectedBackupId = backup.id;

                            case 3:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this3);
            }))();
        },
        deleteBackupConfirm: function deleteBackupConfirm() {
            var _this4 = this;

            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _context4.next = 2;
                                return Object(__WEBPACK_IMPORTED_MODULE_3__api__["r" /* deleteBackup */])(_this4.selectedBackupId);

                            case 2:
                                _this4.closeModal(true);

                            case 3:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, _this4);
            }))();
        },
        downloadBackup: function downloadBackup(id, fileName) {
            var _this5 = this;

            var knownSize = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
                var followConfig, blob, a, url;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                _this5.activeModal = 'Progress';
                                _this5.bytesReceived = 0;
                                _this5.bytesToReceive = 0;
                                _this5.downloadController = new AbortController();

                                followConfig = {
                                    signal: _this5.downloadController.signal,
                                    onDownloadProgress: function onDownloadProgress(progressEvent) {
                                        var _parseProgress = Object(__WEBPACK_IMPORTED_MODULE_11__util_progress__["a" /* parseProgress */])(progressEvent, knownSize),
                                            loaded = _parseProgress.loaded,
                                            total = _parseProgress.total;

                                        context.bytesReceived = loaded;
                                        context.bytesToReceive = total;
                                    }
                                };
                                _context5.prev = 5;
                                _context5.next = 8;
                                return Object(__WEBPACK_IMPORTED_MODULE_3__api__["_15" /* getBackupById */])(id, followConfig);

                            case 8:
                                blob = _context5.sent;
                                a = document.createElement("a");

                                document.body.appendChild(a);
                                a.style = "display: none";

                                url = window.URL.createObjectURL(blob.data);

                                a.href = url;
                                a.download = fileName;
                                a.click();
                                window.URL.revokeObjectURL(url);
                                a.remove();
                                _context5.next = 23;
                                break;

                            case 20:
                                _context5.prev = 20;
                                _context5.t0 = _context5['catch'](5);

                                if (!__WEBPACK_IMPORTED_MODULE_4_axios__["default"].isCancel(_context5.t0)) {
                                    console.dir(_context5.t0);
                                }

                            case 23:
                                _context5.prev = 23;

                                _this5.activeModal = null;
                                _this5.downloadController = null;
                                return _context5.finish(23);

                            case 27:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, _this5, [[5, 20, 23, 27]]);
            }))();
        },
        cancelDownload: function cancelDownload() {
            if (this.downloadController) {
                this.downloadController.abort();
            }
            this.activeModal = null;
        }
    },
    mounted: function mounted() {
        var _this6 = this;

        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
                while (1) {
                    switch (_context6.prev = _context6.next) {
                        case 0:
                            context = _this6;
                            _this6.getData();

                        case 2:
                        case 'end':
                            return _context6.stop();
                    }
                }
            }, _callee6, _this6);
        }))();
    }
});

/***/ }),

/***/ 2383:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2384);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1502)("de7ece54", content, true, {});

/***/ }),

/***/ 2384:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1501)(true);
// imports


// module
exports.push([module.i, ".progress-container[data-v-13f6a7f8]{margin:10px 20px}#upload-progress[data-v-13f6a7f8]{height:20px;border-radius:5px}", "", {"version":3,"sources":["/Users/sleepingwarrior/BioControl/crfi-monitoring/UI/crfi_monitoring/src/views/BackupManagement.vue"],"names":[],"mappings":"AACA,qCACI,gBAAkB,CACrB,AACD,kCACI,YAAa,AACb,iBAAmB,CACtB","file":"BackupManagement.vue","sourcesContent":["\n.progress-container[data-v-13f6a7f8] {\n    margin: 10px 20px;\n}\n#upload-progress[data-v-13f6a7f8] {\n    height: 20px;\n    border-radius: 5px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 2385:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"view-container"},[_c('modal',{attrs:{"showDialog":_vm.activeModal === 'DELETE',"title":_vm.$t('DELETEBACKUP')},on:{"close":_vm.closeModal}},[_c('delete-confirm',{attrs:{"text":_vm.actionText},on:{"cancel":_vm.closeModal,"confirm":_vm.deleteBackupConfirm}})],1),_vm._v(" "),_c('Modal',{attrs:{"title":_vm.$t('DownloadProgress'),"showDialog":_vm.activeModal == 'Progress'},on:{"close":_vm.cancelDownload}},[_c('div',{staticClass:"progress-container vertical",staticStyle:{"min-width":"30vw"}},[_c('ProgressBar',{attrs:{"loaded":_vm.bytesReceived,"total":_vm.bytesToReceive}}),_vm._v(" "),_c('button',{staticClass:"cancel-button semi-bold",staticStyle:{"margin-top":"12px"},on:{"click":_vm.cancelDownload}},[_vm._v(_vm._s(_vm.$t('Cancel')))])],1)]),_vm._v(" "),_c('div',[_c('div',{staticClass:"max-grid"},[_c('ejs-grid',{ref:"grid",attrs:{"height":"100%","width":"100%","toolbar":_vm.toolbar,"selectionSettings":_vm.selectionOptions,"allowTextWrap":true,"textWrapSettings":_vm.wrapSettings,"dataBound":_vm.dataBound,"dataSource":_vm.backups,"allowPaging":true,"pageSettings":_vm.pageSettings,"allowFiltering":true,"filterSettings":_vm.filterOptions,"allowSorting":true,"allowMultiSorting":true,"allowPdfExport":true,"allowCsvExport":true,"allowExcelExport":true,"showBusyIndicator":true}},[_c('e-columns',[_c('e-column',{attrs:{"field":"systemName","headerText":_vm.$t('SystemName'),"textAlign":"Left","filter":_vm.filterCheckBox,"customAttributes":_vm.customAttributes}}),_vm._v(" "),_c('e-column',{attrs:{"field":"createDate","headerText":_vm.$t('CreateDate'),"textAlign":"Left","type":"date","format":_vm.dateTimeFormatOptions,"customAttributes":_vm.customAttributes,"filter":_vm.filterCheckBox}}),_vm._v(" "),_c('e-column',{attrs:{"field":"receivedDate","headerText":_vm.$t('ReceivedDate'),"textAlign":"Left","type":"date","format":_vm.dateTimeFormatOptions,"customAttributes":_vm.customAttributes,"filter":_vm.filterCheckBox}}),_vm._v(" "),_c('e-column',{attrs:{"field":"sizeText","headerText":_vm.$t('FileSize'),"textAlign":"Left","customAttributes":_vm.customAttributes}}),_vm._v(" "),_c('e-column',{attrs:{"field":"id","headerText":"","width":"150px","allowSorting":false,"allowFiltering":false,"template":_vm.optionsTemplate}})],1)],1)],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/19.1c1d345719439d1813d7.js